import { render, staticRenderFns } from "./NlpCoinSelect.vue?vue&type=template&id=2b202e39"
import script from "./NlpCoinSelect.vue?vue&type=script&lang=js"
export * from "./NlpCoinSelect.vue?vue&type=script&lang=js"
import style0 from "./NlpCoinSelect.vue?vue&type=style&index=0&id=2b202e39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports